import { render, staticRenderFns } from "./TelegramPartial.htm?vue&type=template&id=8fb6bab6&scoped=true&external"
import script from "./TelegramPartial.js?vue&type=script&lang=js&external"
export * from "./TelegramPartial.js?vue&type=script&lang=js&external"
import style0 from "./TelegramPartial.scss?vue&type=style&index=0&id=8fb6bab6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb6bab6",
  null
  
)

export default component.exports